/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import api from "../../api/api";
import { useTranslation } from "react-i18next";
const CollectedFdwEmployer = () => {
  const { id } = useParams();
  const history = useHistory();
  const [employerData, setEmployerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchEmployerData = async () => {
      try {
        setLoading(true);
       const response = await api.get(`/collect-info-employer/${id}/`);
        console.log("API Response:", response.data); // Debug log
       
        setEmployerData(response.data.data); // Access nested data property
       
      } catch (error) {
        console.error("Error fetching employer data:", error);
        setError(error.response.status);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchEmployerData();
    } else {
      setError(t("No employer ID provided"));
      setLoading(false);
    }
  }, [id]);

  const formatDate = (dateString) => {
    if (!dateString) return t("Not provided");
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const formatBoolean = (value) => {
    return value ? t("Yes") : t("No");
  };

  const InfoSection = ({ title, children }) => (
    <div className="card mb-4">
      <div className="card-header">
        <h5 className="mb-0 text-primary">{title}</h5>
      </div>
      <div className="card-body">
        {children}
      </div>
    </div>
  );

  const InfoRow = ({ label, value }) => (
    <div className="row mb-2">
      <div className="col-md-4">
        <strong>{label}:</strong>
      </div>
      <div className="col-md-8">
        {value || t("Not provided")}
      </div>
    </div>
  );

  const HouseholdTable = ({ data, t }) => (
    <div className="table-responsive">
      <table className="table table-bordered">
        <thead className="table-light">
          <tr>
            <th>{t("Category")}</th>
            <th>{t("Male")}</th>
            <th>{t("Female")}</th>
            <th>{t("Total")}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{t("Adults")}</td>
            <td>{data.adults_m || 0}</td>
            <td>{data.adults_f || 0}</td>
            <td>{(data.adults_m || 0) + (data.adults_f || 0)}</td>
          </tr>
          <tr>
            <td>{t("New Born Babies")}</td>
            <td>{data.babies_m || 0}</td>
            <td>{data.babies_f || 0}</td>
            <td>{(data.babies_m || 0) + (data.babies_f || 0)}</td>
          </tr>
          <tr>
            <td>{t("Children")}</td>
            <td>{data.children_m || 0}</td>
            <td>{data.children_f || 0}</td>
            <td>{(data.children_m || 0) + (data.children_f || 0)}</td>
          </tr>
          <tr>
            <td>{t("Elderly")}</td>
            <td>{data.elderly_m || 0}</td>
            <td>{data.elderly_f || 0}</td>
            <td>{(data.elderly_m || 0) + (data.elderly_f || 0)}</td>
          </tr>
        </tbody>
        <tfoot className="table-light">
          <tr>
            <th>{t("Total Household Members")}</th>
            <th>{(data.adults_m || 0) + (data.babies_m || 0) + (data.children_m || 0) + (data.elderly_m || 0)}</th>
            <th>{(data.adults_f || 0) + (data.babies_f || 0) + (data.children_f || 0) + (data.elderly_f || 0)}</th>
            <th>{
              (data.adults_m || 0) + (data.adults_f || 0) + 
              (data.babies_m || 0) + (data.babies_f || 0) + 
              (data.children_m || 0) + (data.children_f || 0) + 
              (data.elderly_m || 0) + (data.elderly_f || 0)
            }</th>
          </tr>
        </tfoot>
      </table>
    </div>
  );

  const JobScopeList = ({ data,t }) => {
    const jobScopeItems = [
      { key: "baby_care", label: t("Baby Care") },
      { key: "infant_care", label: t("Infant Care") },
      { key: "child_care", label: t("Child Care") },
      { key: "elderly_care", label: t("Elderly Care") },
      { key: "elderly_nursing", label: t("Elderly Care (Nursing)") },
      { key: "invalid_care", label: t("Invalid Care") },
      { key: "gardening", label: t("Gardening") },
      { key: "laundry", label: t("Laundry") },
      { key: "marketing", label: t("Marketing") },
      { key: "pet_care", label: t("Pet Care") },
      { key: "car_wash", label: t("Car Wash") }
    ];

    const selectedItems = jobScopeItems.filter(item => data[item.key]);

    return (
      <div>
        {data.cooking_food && (
          <InfoRow label={t("Cooking Food")} value={data.cooking_food} />
        )}
        
        <div className="row mb-2">
          <div className="col-md-4">
            <strong>{t("Job Scope")}:</strong>
          </div>
          <div className="col-md-8">
            {selectedItems.length > 0 ? (
              <ul className="list-unstyled mb-0">
                {selectedItems.map(item => (
                  <li key={item.key} className="mb-1">
                    <i className="fas fa-check text-success me-2"></i>
                    {item.label}
                  </li>
                ))}
              </ul>
            ) : (
              t("No specific job scope selected")
            )}
          </div>
        </div>

        {data.job_remarks && (
          <InfoRow label={t("Remarks/Special Requirements")} value={data.job_remarks} />
        )}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="container p-4">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">{t("Loading...")}</span>
          </div>
          <p className="mt-2">{t("Loading employer information...")}</p>
        </div>
      </div>
    );
  }

  if (error === 400) {
    return (
      <div className="container p-4">
        <div className="alert alert-danger">
          <h4>{t("Error Loading Data")}</h4>
          <p>{error}</p>
          <button 
            className="btn btn-secondary" 
            onClick={() => {
              //if (window.history.length > 1) {
               // history.goBack();
              ///} else {
                history.push('/employer-management'); // fallback route
             /// }
            }}
          >
            {t("Go Back")}
          </button>
        </div>
      </div>
    );
  }
  if(error === 404){
    return (
      <div className="container p-4">
        <div className="text-center py-5">
          <i className="fas fa-hourglass-half fa-3x text-primary mb-3"></i>
          <h4 className="text-dark mb-2">{t("Waiting for Submission")}</h4>
          <p className="text-muted mb-3">
            <i className="fas fa-clock me-1"></i>
            {t("We are waiting for the employer to submit the form")}
          </p>
          <button 
            className="btn btn-secondary"
            onClick={() => {
              if (window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = '/employers';
              }
            }}
          >
            <i className="fas fa-arrow-left me-2"></i>
            {t("Back")}
          </button>
        </div>
      </div>
    );
  }
  //empty (no invitation yet)  <ConfirmCollectInformationModal employer={selectedEmployer} refresh={() => {}} />
  if (employerData && employerData.length === 0) {
    return (
      <div className="container p-4">
        <div className="text-center py-5">
          <i className="fas fa-user-times fa-3x text-muted mb-3"></i>
          <h4 className="text-dark mb-2">{t("No Information Available")}</h4>
          <p className="text-muted mb-3">
            <i className="fas fa-info-circle me-1"></i>
            {t("No invitation to collect information for this employer")}
          </p>
          <button 
            className="btn btn-secondary"
            onClick={() => {
              history.push('/employer-management');
            }}
          >
            <i className="fas fa-arrow-left me-2"></i>
            {t("Back")}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container pt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0 text-primary">{t("Employer Information")}</h4>
       <button 
                  className="btn btn-outline-secondary" 
                  onClick={() => {
                   // if (window.history.length > 1) {
                      //history.goBack();
                    //} else {
                      history.push('/employer-management'); // fallback route
                    //}
                  }}
                  style={{
                    borderRadius: '8px',
                    padding: '10px 20px',
                    fontWeight: '600'
                  }}
                >
                  <i className="fas fa-arrow-left me-2"></i>
                  {t("Back")}
                </button>
      </div>

      <div className="row">
        {/* Employer Information */}
        <div className="col-lg-6 col-md-12 mb-4">
          <InfoSection title={t("Employer Details")}>
            <InfoRow label={t("Salutation")} value={employerData.salutation} />
            <InfoRow label={t("Employer Name")} value={employerData.employer_name} />
            <InfoRow label={t("NRIC/Passport No.")} value={employerData.nric_passport} />
            <InfoRow label={t("FIN")} value={employerData.fin} />
            <InfoRow label={t("Citizenship")} value={employerData.citizenship} />
            <InfoRow label={t("Residence Status")} value={employerData.residence_status} />
            <InfoRow label={t("Date of Birth")} value={formatDate(employerData.date_of_birth)} />
            <InfoRow label={t("Occupation")} value={employerData.occupation} />
            <InfoRow label={t("Company")} value={employerData.company} />
            <InfoRow label={t("Religion")} value={employerData.religion} />
            <InfoRow label={t("Marital Status")} value={employerData.marital_status} />
            <InfoRow label={t("Marriage Registered in Singapore")} value={formatBoolean(employerData.marriage_registered)} />
            <InfoRow label={t("Employer Type")} value={employerData.employer_type} />
          </InfoSection>

          <InfoSection title={t("Property Information")}>
            <InfoRow label={t("Property Type")} value={employerData.property_type} />
            {employerData.other_property_type && (
              <InfoRow label={t("Other Property Type")} value={employerData.other_property_type} />
            )}
            <InfoRow label={t("Number of Levels")} value={employerData.no_of_levels || 0} />
            <InfoRow label={t("Number of Rooms")} value={employerData.no_of_rooms || 0} />
            <InfoRow label={t("Number of Washrooms")} value={employerData.no_of_washrooms || 0} />
          </InfoSection>
        </div>

        {/* Spouse Information */}
        <div className="col-lg-6 col-md-12 mb-4">
          <InfoSection title={t("Spouse Information")}>
            <InfoRow label={t("Salutation")} value={employerData.spouse_salutation} />
            <InfoRow label={t("Spouse Name")} value={employerData.spouse_name} />
            <InfoRow label={t("NRIC/Passport No.")} value={employerData.spouse_nric_passport} />
            <InfoRow label={t("Citizenship")} value={employerData.spouse_citizenship} />
            <InfoRow label={t("Date of Birth")} value={formatDate(employerData.spouse_date_of_birth)} />
            <InfoRow label={t("Occupation")} value={employerData.spouse_occupation} />
            <InfoRow label={t("Company")} value={employerData.spouse_company} />
            <InfoRow label={t("Religion")} value={employerData.spouse_religion} />
            {employerData.spouse_remarks && (
              <InfoRow label={t("Remarks")} value={employerData.spouse_remarks} />
            )}
          </InfoSection>

          <InfoSection title={t("Contact Information")}>
            <InfoRow label={t("Address Line 1")} value={employerData.address_line1} />
            <InfoRow label={t("Address Line 2")} value={employerData.address_line2} />
            <InfoRow label={t("Contact No.")} value={employerData.contact_no} />
            <InfoRow label={t("Home No.")} value={employerData.home_no} />
            <InfoRow label={t("Office No.")} value={employerData.office_no} />
            <InfoRow label={t("Email Address")} value={employerData.email_address} />
          </InfoSection>
        </div>
      </div>

      <div className="row">
        {/* Household Members */}
        <div className="col-lg-6 col-md-12 mb-4">
          <InfoSection title={t("Household Members")}>
            <HouseholdTable data={employerData} t={t} />
          </InfoSection>
        </div>

        {/* Job Scope */}
        <div className="col-lg-6 col-md-12 mb-4">
          <InfoSection title={t("FDW Job Scope Requirements")}>
            <JobScopeList data={employerData} t={t}/>
          </InfoSection>
        </div>
      </div>
    </div>
  );
};

export default CollectedFdwEmployer;
